import { observer } from 'mobx-react-lite'
import { Button } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import i from '../../../translations/i'
import { AuthHead } from '../../../front/user/shell/AuthShell'

// Почта подтверждена: менеджер создаст панель, после этого можно входить
export const VerifySuccessComponent = observer(() => (
    <>
        <AuthHead icon={<CheckOutlined />} title={i.t('auth:title.verifySuccess')} text={i.t('auth:verify.success')} />
        <Button size="large" type="primary" block href="/login" style={{ height: 50, borderRadius: 14, fontWeight: 700 }}>
            {i.t('def:actions.enter')}
        </Button>
    </>
))
